import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class EtsDataOperationsUserType {
  public readonly key = 'EtsDataOperationsUserType';
  public readonly enrollTrackRole = EnrollTrackRole.EtsDataOperations;
}
